import type { AdminLeadsResponse, LeadSubmission, LeadSubmitResponse } from '@/types/lead';

export { emptyForm, buildSubmission } from '@/lib/leadPayload';

const API_BASE = (import.meta.env.VITE_API_BASE_URL || '/api').replace(/\/$/, '');

export async function submitLead(payload: LeadSubmission): Promise<LeadSubmitResponse> {
  const res = await fetch(`${API_BASE}/collections/leads`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  let data: LeadSubmitResponse;
  try {
    data = (await res.json()) as LeadSubmitResponse;
  } catch {
    data = { ok: res.ok };
  }

  if (!res.ok && data.ok === undefined) {
    return { ok: false, error: `http_${res.status}` };
  }
  return data;
}

export async function fetchAdminLeads(adminKey: string): Promise<AdminLeadsResponse> {
  const res = await fetch(`${API_BASE}/collections/admin/leads`, {
    method: 'GET',
    headers: { 'X-Admin-Key': adminKey },
  });

  let data: AdminLeadsResponse;
  try {
    data = (await res.json()) as AdminLeadsResponse;
  } catch {
    data = { ok: res.ok, count: 0, items: [] };
  }

  if (!res.ok) {
    return { ok: false, count: 0, items: [], error: `http_${res.status}` };
  }
  return data;
}
